export const wingitDesign = {
  colors: {
    page: '#07111f',
    surface: '#111c2e',
    surfaceElevated: '#17263d',
    surfaceSoft: '#1d304b',

    border: 'rgba(120, 180, 255, 0.22)',
    borderStrong: 'rgba(120, 200, 255, 0.38)',

    text: '#f3f8ff',
    textMuted: '#9fb7d4',
    textSoft: '#c9d9ec',

    primary: '#55c7ff',
    primarySoft: 'rgba(85, 199, 255, 0.14)',

    success: '#37d67a',
    successSoft: 'rgba(55, 214, 122, 0.14)',

    warning: '#ffbf47',
    warningSoft: 'rgba(255, 191, 71, 0.16)',

    danger: '#ff5d73',
    dangerSoft: 'rgba(255, 93, 115, 0.16)',

    muted: '#7188a6',
  },

  radius: {
    small: 10,
    medium: 14,
    large: 18,
    xl: 24,
  },

  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 20,
    xl: 24,
    xxl: 32,
    xxxl: 48,
  },

  shadow: {
    card: '0 14px 40px rgba(0, 0, 0, 0.24)',
    elevated: '0 20px 60px rgba(0, 0, 0, 0.34)',
    glow: '0 0 30px rgba(85, 199, 255, 0.14)',
  },

  transition: {
    fast: '120ms ease',
    normal: '180ms ease',
    slow: '300ms ease',
  },

    typography: {
    pageTitle: {
      fontSize: '1.9rem',
      fontWeight: 700,
      letterSpacing: '-0.03em',
      lineHeight: 1.08,
    },

    sectionTitle: {
      fontSize: '1.08rem',
      fontWeight: 700,
      letterSpacing: '-0.01em',
    },

    cardTitle: {
      fontSize: '0.96rem',
      fontWeight: 700,
      letterSpacing: '0',
    },

    body: {
      fontSize: '0.95rem',
      lineHeight: 1.6,
    },

    caption: {
      fontSize: '0.75rem',
      letterSpacing: '0.06em',
      textTransform: 'uppercase',
    },
  },

  layout: {
    page: {
      minHeight: '100vh',
      background: 'linear-gradient(180deg, #07111f 0%, #10172a 48%, #15182b 100%)',
      color: '#f3f8ff',
      padding: '1.25rem',
    },

    shell: {
      width: '100%',
      maxWidth: 980,
      margin: '0 auto',
    },

    narrowShell: {
      width: '100%',
      maxWidth: 860,
      margin: '0 auto',
    },
  },

  cards: {
    primary: {
      background: 'linear-gradient(145deg, rgba(23, 38, 61, 0.96), rgba(13, 24, 40, 0.96))',
      border: '1px solid rgba(120, 180, 255, 0.22)',
      borderRadius: 18,
      padding: 20,
      boxShadow: '0 14px 40px rgba(0, 0, 0, 0.24)',
    },

    secondary: {
      background: 'rgba(17, 28, 46, 0.9)',
      border: '1px solid rgba(120, 180, 255, 0.18)',
      borderRadius: 18,
      padding: 20,
    },

    section: {
      background: 'rgba(23, 38, 61, 0.78)',
      border: '1px solid rgba(120, 180, 255, 0.18)',
      borderRadius: 16,
      padding: '1rem 1.1rem',
      marginBottom: '1rem',
    },

    muted: {
      background: 'rgba(17, 28, 46, 0.52)',
      border: '1px solid rgba(120, 180, 255, 0.12)',
      borderRadius: 18,
      padding: 20,
      opacity: 0.58,
    },
  },

  buttons: {
    primary: {
      background: 'linear-gradient(135deg, #55c7ff, #3aa8e8)',
      color: '#06111f',
      border: 'none',
      borderRadius: 999,
      padding: '0.7rem 1.05rem',
      fontWeight: 800,
      cursor: 'pointer',
      boxShadow: '0 10px 24px rgba(85, 199, 255, 0.22)',
    },

    secondary: {
      background: 'rgba(85, 199, 255, 0.08)',
      color: '#dff5ff',
      border: '1px solid rgba(85, 199, 255, 0.28)',
      borderRadius: 999,
      padding: '0.7rem 1.05rem',
      fontWeight: 750,
      cursor: 'pointer',
    },

    ghost: {
      background: 'transparent',
      color: '#9fb7d4',
      border: '1px solid rgba(159, 183, 212, 0.2)',
      borderRadius: 999,
      padding: '0.65rem 1rem',
      fontWeight: 700,
      cursor: 'pointer',
    },

    link: {
      background: 'rgba(182,234,255,0.10)',
      color: '#d9f4ff',
      border: '1px solid rgba(182,234,255,0.22)',
      borderRadius: 999,
      padding: '0.48rem 0.75rem',
      fontSize: '0.78rem',
      fontWeight: 850,
      letterSpacing: '0.04em',
      cursor: 'pointer',
    },
  },

  inputs: {
    select: {
      padding: '0.6rem',
      borderRadius: 10,
      border: '1px solid rgba(120, 180, 255, 0.28)',
      background: '#10233a',
      color: '#ffffff',
      fontWeight: 700,
    },
  },

  chips: {
    success: {
      background: 'rgba(55, 214, 122, 0.14)',
      color: '#b9ffd4',
      border: '1px solid rgba(55, 214, 122, 0.3)',
    },

    warning: {
      background: 'rgba(255, 191, 71, 0.16)',
      color: '#ffe3a3',
      border: '1px solid rgba(255, 191, 71, 0.32)',
    },

    danger: {
      background: 'rgba(255, 93, 115, 0.16)',
      color: '#ffc0ca',
      border: '1px solid rgba(255, 93, 115, 0.34)',
    },

    info: {
      background: 'rgba(85, 199, 255, 0.14)',
      color: '#c9f1ff',
      border: '1px solid rgba(85, 199, 255, 0.3)',
    },

    muted: {
      background: 'rgba(159, 183, 212, 0.1)',
      color: '#9fb7d4',
      border: '1px solid rgba(159, 183, 212, 0.18)',
    },
  },
    publicPages: {
    page: {
      minHeight: '100vh',
      background:
        'radial-gradient(circle at top, rgba(85,199,255,0.08), transparent 34%), linear-gradient(180deg, #06111f, #050914 70%)',
      color: '#ffffff',
      padding: '1.25rem',
    },

    topBar: {
      maxWidth: 980,
      margin: '0 auto',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '1rem',
    },

    topButton: {
      border: '1px solid rgba(85,199,255,0.24)',
      background: 'rgba(255,255,255,0.025)',
      color: '#d7ebff',
      borderRadius: 10,
      padding: '0.55rem 0.9rem',
      fontWeight: 700,
      cursor: 'pointer',
    },

    hero: {
      maxWidth: 620,
      margin: '4.2rem auto 0',
      textAlign: 'center',
    },

    title: {
      margin: 0,
      color: '#ffffff',
      fontSize: '2.4rem',
      fontWeight: 800,
      letterSpacing: '-0.04em',
    },

    subtitle: {
      maxWidth: 580,
      margin: '1rem auto 0',
      color: '#b6cbe3',
      fontSize: '1.05rem',
      lineHeight: 1.6,
    },

    panel: {
      marginTop: '2.4rem',
      textAlign: 'left',
      padding: '1.5rem',
      borderRadius: 14,
      background: '#0b1828',
      border: '1px solid rgba(85,199,255,0.14)',
    },

    input: {
      width: '100%',
      boxSizing: 'border-box',
      border: '1px solid rgba(85,199,255,0.2)',
      background: 'rgba(255,255,255,0.04)',
      color: '#ffffff',
      borderRadius: 10,
      padding: '0.75rem 0.85rem',
      fontSize: '0.98rem',
      outline: 'none',
    },

    primaryButton: {
      border: 'none',
      background: '#55c7ff',
      color: '#04111f',
      borderRadius: 10,
      padding: '0.75rem 1rem',
      fontWeight: 800,
      cursor: 'pointer',
      width: '100%',
    },
  },
};

export default wingitDesign;